import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { PeoFacadeService } from "./peo-facade.service";
import {ProcessEtapeOpe} from "../../models/peo.model";

@Injectable({ providedIn: "root" })
export class PeoStoreService extends EntityStoreService<
  ProcessEtapeOpe,
  EntityMetadata,
  PeoState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface PeoState extends EntityStoreState<PeoFacadeService> {}
